

import React, { useState } from 'react';
import { Switch, FormControlLabel, Grid, TextField, Box, Button, Tooltip, IconButton } from '@mui/material';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import Swal from 'sweetalert2'; // Importar sweetalert2 para mostrar los mensajes
import L from 'leaflet';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import markerIconRetina from 'leaflet/dist/images/marker-icon-2x.png';
import GeoSearch from '../../../AdvancedMonitoringMapScreen/Map/GeoSearch/GeoSearch';
import { fetchConToken } from '../../../../helpers/fetch';
import { NewUsersContract } from './NewUsersContract/NewUsersContract';
import { useSelector } from 'react-redux';
const DefaultIcon = L.icon({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIconRetina,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

L.Marker.prototype.options.icon = DefaultIcon;

const LocationMarker = ({ setCoordinates }) => {
  const [position, setPosition] = useState(null);

  useMapEvents({
    click(e) {
      const { lat, lng } = e.latlng;
      setPosition([lat, lng]);
      setCoordinates(lat, lng);
    },
  });

  return position ? (
    <Marker position={position}>
      <Popup>
        Latitud: {position[0]}, Longitud: {position[1]}
      </Popup>
    </Marker>
  ) : null;
};

export const NewContractForm = () => {
  const contractsState = useSelector((state) => state.contracts.contracts);
  const [usersData, setUsersData] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    number_of_gateways: 1,
    shipping_frequency: 24,
    storage_frequency: 0,
    mask_of_measures_to_store: 0,
    status_holidays: 1,
    alarms_mask: 143,
    min_voltage: 200,
    max_voltage: 250,
    min_current: 20,
    max_current: 1500,
    max_temperature: 70,
    mask_of_moments_to_store: 0,
    status_flag: 0,
    location: '',
    longitude: '',
    latitude: '',
    warning_mail_1: '',
    warning_mail_2: '',
    warning_mail_3: '',
    p2p_version: 2,
    panel_version: 2,
    failure_window_in_hours: 24,
    failure_window_in_hours_panels: 24,
    default_dimming_profile_id: 0,
    default_exception_profile_id: 0,
    only_ip: 0,
    maintenance: 0,
    default_dimming: 60,
    u6me2: 1,
    smart_lighting_analytics: 0,
    idDb_node_red: null,
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : value,
    });
  };

  const setCoordinates = (lat, lng) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      latitude: lat.toString(),
      longitude: lng.toString(),
    }));
  };


  const handleUserSelectionChange = (selectedUsers) => {
    const updatedUsers = selectedUsers.map((user) => ({
      ...user,
      name: formData.name,
    }));

    setUsersData(updatedUsers);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.location || !formData.latitude || !formData.longitude) {
      Swal.fire({
        icon: 'warning',
        title: 'Campos incompletos',
        text: 'Debes completar todos los campos del formulario antes de crear un nuevo contrato.',
      });
      return;
    }
    const contractNameAlreadyExists = contractsState.some((item) => {
      return (item.name.toLowerCase() == formData.name.toLowerCase());
    });

    if (contractNameAlreadyExists) {

      Swal.fire({
        icon: 'warning',
        title: 'Nombre de contrato ya existente',
        text: 'Debes cambiar el nombre del contrato',
      });
      return
    }

    const payload = [formData, usersData];


    try {
      const response = await fetchConToken('contract/newcontract', payload, 'POST');

      if (response.ok) {
        const data = await response.json();
        Swal.fire({
          icon: 'success',
          title: 'Contrato creado',
          text: `El contrato fue creado con éxito. ID del nuevo contrato: ${data.idContract}`,
        });

      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Hubo un problema al crear el contrato.',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Ocurrió un error inesperado.',
      });
    }
  };

  const handleReset = () => {
    setFormData({
      name: '',
      number_of_gateways: 1,
      shipping_frequency: 24,
      storage_frequency: 2,
      mask_of_measures_to_store: 0,
      status_holidays: 1,
      alarms_mask: 0,
      min_voltage: 220,
      max_voltage: 240,
      min_current: 10,
      max_current: 15,
      max_temperature: 60,
      mask_of_moments_to_store: 0,
      status_flag: 0,
      location: '',
      longitude: '',
      latitude: '',
      warning_mail_1: '',
      warning_mail_2: '',
      warning_mail_3: '',
      p2p_version: 2,
      panel_version: 2,
      failure_window_in_hours: 24,
      failure_window_in_hours_panels: 24,
      default_dimming_profile_id: 0,
      default_exception_profile_id: 0,
      only_ip: 0,
      maintenance: 0,
      default_dimming: 60,
      u6me2: 1,
      smart_lighting_analytics: 0,
      idDb_node_red: null,
    });
    setUsersData([]);
  };

  return (
    <Box sx={{ maxWidth: 1100, mx: 'auto', p: 3 }}>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={11}>
            <TextField
              fullWidth
              label="Nombre del contrato"
              name="name"
              variant="outlined"
              value={formData.name}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={1}>
            <Tooltip title="Introduzca el nombre del contrato, que sera visible para todos los usuarios que tengan acceso" arrow>
              <IconButton>
                <HelpCenterIcon style={{ color: 'gold' }} />
              </IconButton>
            </Tooltip>
          </Grid>



          <Grid item xs={11}>
            <TextField
              fullWidth
              label="Número de Gateways"
              name="number_of_gateways"
              type="number"
              variant="outlined"
              value={formData.number_of_gateways}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={1}>
            <Tooltip title="Inserte el número de gateways máximo que debe tener el contrato" arrow>
              <IconButton>
                <HelpCenterIcon style={{ color: 'gold' }} />
              </IconButton>
            </Tooltip>
          </Grid>

          <Grid item xs={11}>
            <TextField
              fullWidth
              label="Frecuencia de Envío"
              name="shipping_frequency"
              type="number"
              variant="outlined"
              value={formData.shipping_frequency}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={1}>
            <Tooltip title="Inserte la frecuencia de envío de medidas" arrow>
              <IconButton>
                <HelpCenterIcon style={{ color: 'gold' }} />
              </IconButton>
            </Tooltip>
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Versión P2P"
              name="p2p_version"
              type="number"
              variant="outlined"
              value={formData.p2p_version}
              onChange={handleInputChange}
            />
          </Grid>

          <Grid item xs={5}>
            <TextField
              fullWidth
              label="Versión CM"
              name="panel_version"
              type="number"
              variant="outlined"
              value={formData.panel_version}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={1}>
            <Tooltip title="Información sobre versiones" arrow>
              <IconButton>
                <HelpCenterIcon style={{ color: 'gold' }} />
              </IconButton>
            </Tooltip>
          </Grid>


          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <Box display="flex" alignItems="center">
                <Grid container alignItems="center" spacing={1}>
                  <Grid item>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={formData.maintenance === 1}
                          onChange={handleInputChange}
                          name="maintenance"
                        />
                      }
                      label="Mantenimiento"
                    />
                  </Grid>
                  <Grid item>
                    <Tooltip title="Activar si el contrato incluye servicio de mantenimiento" arrow>
                      <IconButton>
                        <HelpCenterIcon style={{ color: 'gold' }} />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Box display="flex" alignItems="center">
                <Grid container alignItems="center" spacing={1}>
                  <Grid item>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={formData.only_ip === 1}
                          onChange={handleInputChange}
                          name="only_ip"
                        />
                      }
                      label="Only_IP"
                    />
                  </Grid>
                  <Grid item>
                    <Tooltip title="Activar si es NbIoT" arrow>
                      <IconButton>
                        <HelpCenterIcon style={{ color: 'gold' }} />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Box display="flex" alignItems="center">
                <Grid container alignItems="center" spacing={1}>
                  <Grid item>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={formData.u6me2 === 1}
                          onChange={handleInputChange}
                          name="u6me2"
                        />
                      }
                      label="TRIDONIC"
                    />
                  </Grid>
                  <Grid item>
                    <Tooltip title="Soporta driver TRIDONIC" arrow>
                      <IconButton>
                        <HelpCenterIcon style={{ color: 'gold' }} />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            {formData.only_ip === 1 &&
              <>
                <Grid item xs={11}>
                  <TextField
                    fullWidth
                    label="idDB Node-red"
                    name="idDb_node_red"
                    variant="outlined"
                    value={formData.idDb_node_red}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={1}>
                  <Tooltip title="Preguntar idDB para Node-red" arrow>
                    <IconButton>
                      <HelpCenterIcon style={{ color: 'gold' }} />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </>
            }


          </Grid>

          <Grid item xs={11}>
            <TextField
              fullWidth
              label="Municipio"
              name="location"
              variant="outlined"
              value={formData.location}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={1}>
            <Tooltip title="Municipio" arrow>
              <IconButton>
                <HelpCenterIcon style={{ color: 'gold' }} />
              </IconButton>
            </Tooltip>
          </Grid>


          <Grid item xs={6}>
            <TextField
              fullWidth
              label="GPS Latitud"
              name="latitude"
              variant="outlined"
              value={formData.latitude}
              onChange={handleInputChange}
              disabled
            />
          </Grid>

          <Grid item xs={5}>
            <TextField
              fullWidth
              label="GPS Longitud"
              name="longitude"
              variant="outlined"
              value={formData.longitude}
              onChange={handleInputChange}
              disabled
            />
          </Grid>
          <Grid item xs={1}>
            <Tooltip title="Los valores se rellenaran automaticammente al hacer click sobre un punto del mapa" arrow>
              <IconButton>
                <HelpCenterIcon style={{ color: 'gold' }} />
              </IconButton>
            </Tooltip>
          </Grid>

          <Grid item xs={12}>
            <MapContainer center={[40.40, -3.70]} zoom={6} style={{ height: 400, width: '100%' }}>
              <GeoSearch />
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                referrerPolicy="origin"
              />
              <LocationMarker setCoordinates={setCoordinates} />
            </MapContainer>
          </Grid>



          <Grid item xs={12}>
            <NewUsersContract onSelectedUsersChange={handleUserSelectionChange} />
          </Grid>
          <Grid item xs={12} display="flex" justifyContent="space-between">
            <Grid item xs={6} pr={1}>
              <Button type="submit" variant="contained" color="primary" onClick={handleSubmit} fullWidth>
                Enviar
              </Button>
            </Grid>
            <Grid item xs={6} pl={1}>
              <Button type="button" variant="outlined" color="secondary" onClick={handleReset} fullWidth>
                Resetear
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form >
    </Box >
  );
};
